module.exports = __webpack_public_path__ + "media/images/front/academy-cce1704b8432597daa489a8460883303.png";